module.exports = __webpack_public_path__ + "static/media/Logo-Center.f0f3e9a7.png";